<ion-content class="background">
  <div class="space-32"></div>
  <app-title title="Escoge tu país"></app-title>

  <ion-grid class="section-btn">
    <ion-row class="ion-justify-content-center">
      <ion-col size="12">
        <div class="library-list">
          <button (click)="selectCountry('es_Ar')" class="btn-option">
            <span> Argentina </span>
          </button>
        </div>
        <div class="library-list">
          <button (click)="selectCountry('es_Ch')" class="btn-option">
            <span> Chile </span>
          </button>
        </div>
        <div class="library-list">
          <button (click)="selectCountry('es_Pa')" class="btn-option">
            <span> Paraguay </span>
          </button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
